import { Instagram, Music2, Facebook, Youtube } from "lucide-react";
import { Reveal } from "./Reveal";

const SOCIALS = [
  {
    icon: Instagram,
    label: "Instagram",
    handle: "@croclab.es",
    href: "https://www.instagram.com/croclab.es",
    id: "instagram",
  },
  {
    icon: Music2,
    label: "TikTok",
    handle: "@croc.lab",
    href: "https://www.tiktok.com/@croc.lab",
    id: "tiktok",
  },
  {
    icon: Facebook,
    label: "Facebook",
    handle: "CROC LAB",
    href: "https://www.facebook.com/share/1GiyxjfyjM/?mibextid=wwXIfr",
    id: "facebook",
  },
  {
    icon: Youtube,
    label: "YouTube",
    handle: "@CrocLabofficial",
    href: "https://www.youtube.com/@CrocLabofficial",
    id: "youtube",
  },
];

const Social = () => (
  <section id="social" data-testid="social-section" className="py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal className="max-w-2xl">
        <p className="text-sm font-semibold uppercase tracking-widest text-brand-pink">Social</p>
        <h2 className="mt-3 font-display font-bold tracking-tight text-brand-charcoal text-3xl md:text-4xl">
          Síguenos la pista
        </h2>
        <p className="mt-4 text-base md:text-lg text-brand-charcoal/75 leading-relaxed">
          Promos, novedades y mucho CROC. Síguenos y no te pierdas nada.
        </p>
      </Reveal>
      <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {SOCIALS.map((social, i) => (
          <Reveal key={social.id} delay={i * 0.06} className="h-full">
            <a
              data-testid={`social-tile-${social.id}`}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.id === "youtube" ? "Croc Lab on YouTube" : `${social.label} de CROC LAB (se abre en una pestaña nueva)`}
              className="w-full aspect-square rounded-3xl bg-white border border-brand-charcoal/10 shadow-sm flex flex-col items-center justify-center gap-3 hover:shadow-md hover:-translate-y-1 transition-all duration-300"
            >
              <social.icon className="w-8 h-8 text-brand-pink" aria-hidden="true" />
              <span className="text-sm font-semibold text-brand-charcoal">{social.label}</span>
              <span className="text-xs text-brand-charcoal/50">{social.handle}</span>
            </a>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2} className="mt-10 flex flex-col sm:flex-row gap-4">
        <a
          data-testid="social-instagram-button"
          href="https://www.instagram.com/croclab.es"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 bg-brand-pink text-white font-semibold rounded-full px-8 py-3.5 hover:bg-brand-pink/90 hover:scale-105 transition-transform"
        >
          <Instagram className="w-4 h-4" aria-hidden="true" />
          Instagram · @croclab.es
        </a>
        <a
          data-testid="social-tiktok-button"
          href="https://www.tiktok.com/@croc.lab"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 border-2 border-brand-charcoal text-brand-charcoal font-semibold rounded-full px-8 py-3.5 hover:bg-brand-charcoal hover:text-white transition-colors"
        >
          <Music2 className="w-4 h-4" aria-hidden="true" />
          TikTok · @croc.lab
        </a>
        <a
          data-testid="social-facebook-button"
          href="https://www.facebook.com/share/1GiyxjfyjM/?mibextid=wwXIfr"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 border-2 border-brand-charcoal text-brand-charcoal font-semibold rounded-full px-8 py-3.5 hover:bg-brand-charcoal hover:text-white transition-colors"
        >
          <Facebook className="w-4 h-4" aria-hidden="true" />
          Facebook
        </a>
        <a
          data-testid="social-youtube-button"
          href="https://www.youtube.com/@CrocLabofficial"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Croc Lab on YouTube"
          className="inline-flex items-center justify-center gap-2 border-2 border-brand-charcoal text-brand-charcoal font-semibold rounded-full px-8 py-3.5 hover:bg-brand-charcoal hover:text-white transition-colors"
        >
          <Youtube className="w-4 h-4" aria-hidden="true" />
          YouTube
        </a>
      </Reveal>
    </div>
  </section>
);

export default Social;
